export enum Region {
  Mittelrhein = 'mittelrhein',
  Wuerttemberg = 'wuerttemberg',
  Zuerich = 'zuerich',
}
